// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})


// Ouverture nav menu mobile
var burgerMenuNav = document.getElementById('nav-menu__icon--container');
var closeButtonNav = document.getElementById('nav-menu__icon__close');
var overlayNav = document.getElementById('nav-menu__container');

var itemNavs = document.querySelectorAll('.nav-menu__item');
var flecheMenu = document.getElementById('nav-menu__icon__back');

burgerMenuNav.addEventListener('click', function() {
  	overlayNav.classList.toggle("overlay");
	closeButtonNav.classList.toggle("visible");
});

closeButtonNav.addEventListener('click', function() {
  	overlayNav.classList.toggle("overlay");
	closeButtonNav.classList.toggle("visible");
});

itemNavs.forEach(itemNav => {
    itemNav.addEventListener('click', () => {
        itemNav.classList.toggle("active");
        flecheMenu.classList.toggle("visible");
    })
}) 

flecheMenu.addEventListener('click', function() {
    this.classList.toggle("visible");
    var itemNavActive = document.querySelector('.nav-menu__item.active');
    itemNavActive.classList.toggle("active");
});

